import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import { default as theme } from 'themes';

export const StyledLoader = (): JSX.Element => (
  <TailSpin color={theme.colors.loader.main} height={40} width={40} />
);
